import { render, staticRenderFns } from "./PlanButtonGroup.vue?vue&type=template&id=10389953"
import script from "./PlanButtonGroup.vue?vue&type=script&lang=js"
export * from "./PlanButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./PlanButtonGroup.vue?vue&type=style&index=0&id=10389953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports